import type {
  HrsBaseSeries,
  HrsFinish,
  HrsSeries,
} from "./hrsRackConfigurator";

export const HRS_RACK_CONFIGURATOR_TYPE = "hrs_rack_v1" as const;
export const HRS_RACK_SNAPSHOT_SCHEMA_VERSION = "hrs_rack_v1" as const;

export type HrsRackEquipmentSlotSnapshot = {
  key: string;
  /** Optional for backwards compatibility; older racks inherit configuration.baseSeries. */
  baseSeries?: HrsBaseSeries;
  name: string;
  spacingIn: number;
  widthIn: number | null;
  depthIn: number | null;
  heightIn: number | null;
  weightKg: number | null;
  imageUrl: string | null;
  solidBrace: boolean;
};

export type HrsRackConfigurationData = {
  series: HrsSeries;
  sizeCode: string;
  finish: HrsFinish;
  baseSeries: HrsBaseSeries;
  rackLevels: number[];
  customBase: {
    series: "E1X" | "M3X2";
    widthIn: number;
    depthIn: number;
  } | null;
  slots: HrsRackEquipmentSlotSnapshot[];
};

export type HrsRackConfigurationSnapshot = {
  schemaVersion: typeof HRS_RACK_SNAPSHOT_SCHEMA_VERSION;
  configuratorType: typeof HRS_RACK_CONFIGURATOR_TYPE;
  savedConfigurationId: number;
  replacesSavedConfigurationId: number | null;
  customerName: string;
  configurationName: string;
  customerDisplayName: string;
  friendlyProductName: string;
  customerDescription: string;
  internalOrderDescription: string;
  finalAuthoritativeSgdUnitPrice: number;
  currency: "SGD";
  productImageUrl: null;
  configuration: HrsRackConfigurationData;
  configuredAt: string;
  source: "sales_catalogue_configurator";
};

export function isHrsRackSnapshot(
  value: unknown
): value is HrsRackConfigurationSnapshot {
  return (
    Boolean(value) &&
    typeof value === "object" &&
    (value as { schemaVersion?: unknown }).schemaVersion ===
      HRS_RACK_SNAPSHOT_SCHEMA_VERSION
  );
}
